import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import fetch from '../../utils/fetch';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { addProductsGroup } from '../../store/productsWithGroups';
import PaginationBtn from '../../components/PaginationBtn';
import Product from '../Products/singleproduct';
import Loading from '../../components/Loading';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import icons from '../../utils/icons.json';
import constants from '../../utils/constants.json';
import PriceRange from '../../components/PriceRange';
import SortBy from './SortBy';
import { setBrandsAndColors, sortProducts, filterByBrandsAndColors, isMobile } from '../../utils/fn';
import { Button } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import Topsellingcard from '../Products/topsellingcard';
import { Shuffle } from '../../utils/functions';

function Classifications() {
	useDocumentTitle('Product Classifications');

	const dispatch = useDispatch();
	const location = useLocation()
	const allProducts = useSelector((state) => state.productsWithGroups);
	const categories = useSelector((state) => state.categories.data);

	const [showclassifications, setshowclassifications] = useState(true);


	const allclassifications = location.state?.classifications;
	const [classification, setclassification] = useState(location.state?.classification);

	const { item_group, sub_group } = classification

	const [groupId, setGroupId] = useState(item_group + sub_group);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');


	const [topSellingProducts, settopSellingProducts] = useState([]);
	const [productsToView, setProductsToView] = useState([]);
	const [viewGroupPosition, setViewGroupPosition] = useState(0);
	const [productGroups, setProductGroups] = useState([]);

	const [brands, setBrands] = useState([]);
	const [colors, setColors] = useState([]);

	const [minPriceRange, setMinPriceRange] = useState(constants.MIN_PRICE);
	const [maxPriceRange, setMaxPriceRange] = useState(constants.MAX_PRICE);

	const [sortBy, setSortBy] = useState('rand');
	const [brandFilters, setBrandFilters] = useState([]);
	const [colorFilters, setColorFilters] = useState([]);

	useEffect(() => {
		window.scroll({ top: 0, behavior: 'smooth' });
		setProductsToView(productGroups[viewGroupPosition] || []);
	}, [viewGroupPosition, productGroups]);

	useEffect(() => {
		loadFromSubCategory()
		setGroupId(classification.item_group + classification.sub_group)
	}, [classification]);


	useEffect(() => sortedAndFiltered(), [sortBy, allProducts, colorFilters, brandFilters, minPriceRange, maxPriceRange]);

	useEffect(() => { loadtopselling() }, []);

	function loadtopselling() {
		fetch
			.get('getTopSellingProducts')
			.then((res) => {
				settopSellingProducts(Shuffle(res.list))
			})
			.catch((err) => {
			});
	}


	function sortedAndFiltered() {
		let filtered = allProducts[groupId];
		if (!filtered) return;
		filtered = filtered.itemsarray;

		setBrandsAndColors(filtered, setBrands, setColors);

		filtered = filtered.filter((item) => parseFloat(item.itemPrice) >= minPriceRange && parseFloat(item.itemPrice) <= maxPriceRange);
		filtered = filterByBrandsAndColors(filtered, brandFilters, colorFilters);
		filtered = sortProducts(filtered, sortBy);

		setViewGroupPosition(0);
		setProductGroups(filtered);
	}



	function loadFromSubCategory() {
		setError('');
		setLoading(true);
		setProductGroups([]);
		fetch
			.get('filterWithClassifications', { category: classification.categoryCode })
			.then((res) => {
				setLoading(false);
				setError('');
				dispatch(addProductsGroup({ category: item_group + sub_group, data: res.list }));
			})
			.catch((err) => {
				setLoading(false);
				setError(err.message);
			});

	}

	function brandFilterAction(val, checked) {
		setBrandFilters((brands) => {
			let arr;
			if (checked) {
				arr = [...brands];
				arr.push(val);
			} else {
				arr = brands.filter((brand) => brand != val);
			}
			return arr;
		});
	}

	function colorFilterAction(val, checked) {
		setColorFilters((colors) => {
			let arr;
			if (checked) {
				arr = [...colors];
				arr.push(val);
			} else {
				arr = colors.filter((color) => color != val);
			}
			return arr;
		});
	}


	return (
		<div className="main-body categories-body">
			<div className="sub-header">
				<div className="flex">
					<Link to="/">Home</Link>
					<span>{'/'}</span>
					<Link to={`/allclassifications/${classification?.categoryCode}`}>{_.startCase(classification.categoryName)}</Link>
				</div>
			</div>
			<div className="sections sub-categories">
				<div style={{ display: "flex", justifyContent: "space-between", borderBottom: "2px solid gray", paddingBottom: 3 }}>
					<h3 className="title" style={{ borderRadius: 25, marginTop: 3 }}>Classifications</h3>
					<Button endIcon={!showclassifications ? <ExpandMore /> : <ExpandLess />} onClick={() => setshowclassifications(!showclassifications)}>{showclassifications ? 'Show less' : 'View all'}</Button>
				</div>
				{showclassifications &&
					<div className="body">{' '}
						{Array.isArray(allclassifications) && allclassifications?.map((val, key) => {
							return (
								<div className="link" key={key} onClick={() => setclassification(val)}>
									{val?.categoryName}
									<span dangerouslySetInnerHTML={{ __html: icons.angle_right }}></span>
								</div>
							)
						})}
					</div>}
			</div>
			{error && (
				<div className="sections" style={{ padding: '20px' }}>
					<h3>Error!!</h3>
					<p>{error}</p>
				</div>
			)}
			{!loading && !error && !productGroups && (
				<p className="sections" style={{ padding: '10px 10px 200px' }}>
					Products for the classification you selected is currently not available. Keep checking for updates or visit other allclassifications available.
				</p>
			)}
			{
				<div className="products-category">
					<div className="sub-menu sections">
						<div className="listing">
							<h4>Brand</h4>
							<div className="lists">
								{brands.map((brand, index) => (
									<label className="flex" key={brand.brand + index}>
										<input type="checkbox" onChange={(e) => brandFilterAction(brand.brand, e.target.checked)} />
										<span>{_.upperFirst(brand.brandName)}</span>
									</label>
								))}
								{brands.length === 0 && <label>~</label>}
							</div>
						</div>
						<div className="listing">
							<h4>Colors</h4>
							<div className="lists">
								{colors.map((color, index) => {
									return (
										<label className="flex" key={color.color + index}>
											<input type="checkbox" onChange={(e) => colorFilterAction(color.color, e.target.checked)} />
											<span>{_.upperFirst(color.colorName)}</span>
										</label>
									);
								})}
								{colors.length === 0 && <label>~</label>}
							</div>
						</div>
						<PriceRange
							onRequest={(min, max) => {
								setMinPriceRange(min);
								setMaxPriceRange(max);
							}}
						/>
						<SortBy onSorted={setSortBy} />
						{isMobile() &&
							<div>
								<h4>BEST SELLERS</h4><br />
								<div className='wraptopsellingcards' style={{ height: productsToView.length * 50 }} >
									{topSellingProducts?.map((val, key) => {
										return (
											<Topsellingcard product={val} key={key} />
										)
									})}
								</div>
							</div>
						}
					</div>
					<div className="right-side sections">
						{loading && <Loading />}
						{!loading && (!productsToView || productsToView.length == 0) && <p style={{ padding: '20px 10px' }}>Products Not Found</p>}
						{productsToView && (
							<>
								<div className="products-view">
									{productsToView.map((product, index) => {
										//console.log(product);
										return <Product data={product} key={index} />;
									})}
								</div>
								{productGroups.length > 1 && <PaginationBtn data={{ size: productGroups.length, position: viewGroupPosition, onChange: setViewGroupPosition }} />}
							</>
						)}
					</div>
				</div>
			}
		</div>
	);
}

export default React.memo(Classifications);
